var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "featured-collection",
      class: _vm.featuredCollection.bgColor,
      style: _vm.paddingStyles
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "featured-collection__header" }, [
          _c("h3", { class: _vm.featuredCollection.headingColor }, [
            _vm._v(_vm._s(_vm.featuredCollection.heading))
          ]),
          _c("div", { staticClass: "controls-container" }, [
            _c("div", { staticClass: "arrows" }, [
              _c(
                "div",
                {
                  staticClass: "arrow arrow-prev",
                  on: { click: _vm.slidePrev }
                },
                [
                  _c("icon", {
                    attrs: {
                      "fill-class": _vm.featuredCollection.arrowColor,
                      name: "chevron-left",
                      size: "14px"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "arrow arrow-next",
                  on: { click: _vm.slideNext }
                },
                [
                  _c("icon", {
                    attrs: {
                      "fill-class": _vm.featuredCollection.arrowColor,
                      name: "chevron-right",
                      size: "14px"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "featured-collection__carousel",
            class: { "featured-collection__carousel--hover": _vm.hovered }
          },
          [
            _c(
              "swiper",
              {
                ref: "productImageCarousel",
                class: { "swiper-no-swiping": !_vm.shouldSwipe },
                attrs: { options: _vm.carouselOptions }
              },
              _vm._l(
                _vm.filterProducts(_vm.featuredCollection.products),
                function(product, index) {
                  return _c("swiper-slide", { key: "product-" + index }, [
                    _c(
                      "div",
                      {
                        on: {
                          mouseover: function($event) {
                            _vm.hovered = true
                          },
                          mouseleave: function($event) {
                            _vm.hovered = false
                          }
                        }
                      },
                      [
                        _c("product-tile", {
                          attrs: {
                            simple: _vm.isSimpleProductTile,
                            product: product,
                            onAddToCart: _vm.addToCart,
                            showMobileATC: _vm.showMobileATC,
                            "collection-template": _vm.collectionTemplate,
                            "text-alignment": _vm.productTileTextAlignment,
                            "enable-simple-tile-cta": _vm.enableSimpleTileCta
                          }
                        })
                      ],
                      1
                    )
                  ])
                }
              ),
              1
            )
          ],
          1
        ),
        _vm.featuredCollection.enableCta
          ? _c(
              "div",
              { staticClass: "featured-collection__view-all-button-container" },
              [
                _vm.featuredCollection.enableCta
                  ? _c(
                      "v-button",
                      {
                        staticClass: "featured-collection__view-all-button",
                        class: _vm.featuredCollection.ctaLayout,
                        attrs: {
                          href: _vm.featuredCollection.ctaLink,
                          tag: "a"
                        }
                      },
                      [_vm._v("Shop All")]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }